import { render, staticRenderFns } from "./recibosAvaluos.vue?vue&type=template&id=12d09a5a&scoped=true&"
import script from "./recibosAvaluos.vue?vue&type=script&lang=js&"
export * from "./recibosAvaluos.vue?vue&type=script&lang=js&"
import style0 from "./recibosAvaluos.vue?vue&type=style&index=0&id=12d09a5a&lang=scss&scoped=true&"
import style1 from "./recibosAvaluos.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d09a5a",
  null
  
)

export default component.exports